import React from "react";

const Pagination = ({
  pagination,
  pageSize,
  setPageSize,
  currentPage,
  setCurrentPage,
  PAGE_SIZE_OPTIONS,
  label = "Items per page",
  totalLabel = "total items"
}) => (
  <div className="px-4 sm:px-6 py-3 flex flex-col md:flex-row items-center justify-between border-t border-gray-200 gap-4">
    <div className="flex flex-col sm:flex-row sm:items-center gap-2 text-sm text-gray-700">
      <div>
        {pagination?.pages>0 &&(
          <>
           <span className="font-medium">Page {pagination?.page || 1}</span> of{" "}
           <span className="font-medium">{pagination?.pages}</span>
          </>
        )}
        {pagination?.total>0 && (
          <span className="ml-2 text-gray-500">
            ({pagination.total} {totalLabel})
          </span>
        )}
      </div>
    </div>
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex items-center space-x-2">
        <label htmlFor="items-per-page" className="text-sm text-gray-600 whitespace-nowrap">
          {label}:
        </label>
        <select
          id="items-per-page"
          value={pageSize}
          onChange={e => { setPageSize(Number(e.target.value)); setCurrentPage(1); }}
          className="px-2 py-1 pr-7 border rounded-md text-sm bg-white"
        >
          {PAGE_SIZE_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <button
        onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
        disabled={currentPage === 1}
        className="px-3 py-2 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
      >
        Previous
      </button>
      <div className="flex items-center space-x-1">
        {pagination?.pages && pagination.pages <= 5
          ? Array.from({ length: pagination.pages }, (_, i) => i + 1).map(p => (
              <button
                key={p}
                onClick={() => setCurrentPage(p)}
                className={`px-3 py-2 text-sm rounded-md ${
                  p === currentPage
                    ? "bg-btn-primary text-white"
                    : "bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
                }`}
              >
                {p}
              </button>
            ))
          : <span className="px-3 py-2 text-sm bg-gray-100 rounded-md">{currentPage}</span>}
      </div>
      <button
        onClick={() => setCurrentPage(p => (p < (pagination?.pages || 1) ? p + 1 : p))}
        disabled={currentPage >= (pagination?.pages || 1)}
        className="px-3 py-2 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50"
      >
        Next
      </button>
    </div>
  </div>
);

export default Pagination;